<template>
  <div class="home">
    <div class="main-container">
      <!-- 快速体验和工具入口并列布局 -->
      <el-row :gutter="30" class="main-content">
        <!-- 快速体验区域 -->
        <el-col :span="14">
          <el-card class="demo-card">
            <div slot="header">
              <span class="demo-title">
                <i class="el-icon-magic-stick"></i>
                快速体验
              </span>
            </div>
            
            <el-row :gutter="30">
              <el-col :span="12">
                <div class="demo-controls">
                  <el-form label-position="top">
                    <el-form-item label="选择类型">
                      <el-radio-group v-model="demoType">
                        <el-radio label="qrcode">二维码</el-radio>
                        <el-radio label="barcode">条形码</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    
                    <el-form-item label="输入内容">
                      <el-input 
                        v-model="demoText"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入要生成的内容"
                      />
                    </el-form-item>
                    
                    <div v-if="demoType === 'qrcode'">
                      <el-form-item label="尺寸">
                        <el-slider v-model="demoQrSize" :min="100" :max="400" show-input />
                      </el-form-item>
                      <el-form-item label="容错率">
                        <el-select v-model="demoQrErrorLevel" style="width: 100%;">
                          <el-option label="低 (L) - 约7%" value="L"></el-option>
                          <el-option label="中 (M) - 约15%" value="M"></el-option>
                          <el-option label="四分位 (Q) - 约25%" value="Q"></el-option>
                          <el-option label="高 (H) - 约30%" value="H"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="颜色">
                        <el-color-picker v-model="demoQrColor" />
                      </el-form-item>
                    </div>
                    
                    <div v-if="demoType === 'barcode'">
                      <el-form-item label="格式">
                        <el-select v-model="demoBarcodeFormat">
                          <el-option label="CODE128" value="CODE128" />
                          <el-option label="CODE39" value="CODE39" />
                          <el-option label="EAN13" value="EAN13" />
                          <el-option label="EAN8" value="EAN8" />
                        </el-select>
                      </el-form-item>
                    </div>
                    
                    <el-button type="primary" @click="downloadDemo" :disabled="!demoText">
                      下载图片
                    </el-button>
                  </el-form>
                </div>
              </el-col>
              
              <el-col :span="12">
                <div class="demo-preview">
                  <div v-if="demoType === 'qrcode'" class="qr-preview">
                    <canvas ref="demoQrCanvas" style="border: 1px solid #ddd; border-radius: 8px;"></canvas>
                  </div>
                  <div v-if="demoType === 'barcode'" class="barcode-preview">
                    <canvas ref="demoBarcodeCanvas" style="border: 1px solid #ddd; border-radius: 8px;"></canvas>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </el-col>

        <!-- 批量生成工具入口 -->
        <el-col :span="10">
          <div class="tools-panel">
            <div class="panel-header">
              <h2>批量生成工具</h2>
              <p>选择工具开始批量处理</p>
            </div>
            
            <div class="tool-buttons">
              <div class="tool-button-item" @click="$router.push('/batch-qrcode')">
                <div class="tool-button-icon qrcode-icon">
                  <i class="el-icon-s-grid"></i>
                </div>
                <div class="tool-button-content">
                  <h3>批量二维码生成</h3>
                  <p>Excel导入批量生成，支持图片、PDF导出</p>
                  <el-button type="primary" size="medium">立即使用</el-button>
                </div>
              </div>
              
              <div class="tool-button-item" @click="$router.push('/batch-barcode')">
                <div class="tool-button-icon barcode-icon">
                  <i class="el-icon-files"></i>
                </div>
                <div class="tool-button-content">
                  <h3>批量条形码生成</h3>
                  <p>支持多种条形码格式，支持图片、PDF导出</p>
                  <el-button type="success" size="medium">立即使用</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import JsBarcode from 'jsbarcode'

export default {
  name: 'HomeView',
  data() {
    return {
      demoType: 'qrcode',
      demoText: 'https://www.peifeng.com',
      demoQrSize: 300,
      demoQrColor: '#000000',
      demoQrErrorLevel: 'M',
      demoBarcodeFormat: 'CODE128'
    }
  },
  mounted() {
    this.generateDemo()
  },
  watch: {
    demoText: 'generateDemo',
    demoQrSize: 'generateDemo', 
    demoQrColor: 'generateDemo',
    demoQrErrorLevel: 'generateDemo',
    demoBarcodeFormat: 'generateDemo',
    demoType() {
      if (this.demoType === 'barcode') {
        if (this.demoText === 'https://www.peifeng.com') {
          this.demoText = '1234567890'
        }
      }
      this.$nextTick(() => {
        this.generateDemo()
      })
    }
  },
  methods: {
    generateDemo() {
      if (!this.demoText) return
      
      this.$nextTick(() => {
        if (this.demoType === 'qrcode') {
          this.generateDemoQR()
        } else {
          this.generateDemoBarcode()
        }
      })
    },
    
    async generateDemoQR() {
      try {
        const canvas = this.$refs.demoQrCanvas
        if (!canvas) return
        
        await QRCode.toCanvas(canvas, this.demoText, {
          width: this.demoQrSize,
          errorCorrectionLevel: this.demoQrErrorLevel,
          color: {
            dark: this.demoQrColor,
            light: '#FFFFFF'
          }
        })
      } catch (error) {
        console.error('生成二维码失败:', error)
      }
    },
    
    generateDemoBarcode() {
      try {
        const canvas = this.$refs.demoBarcodeCanvas
        if (!canvas) return
        
        JsBarcode(canvas, this.demoText, {
          format: this.demoBarcodeFormat,
          width: 2,
          height: 100,
          displayValue: true
        })
      } catch (error) {
        console.error('生成条形码失败:', error)
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = '#ff0000'
        ctx.font = '16px Arial'
        ctx.textAlign = 'center'
        ctx.fillText('格式不支持', canvas.width/2, canvas.height/2)
      }
    },
    
    downloadDemo() {
      if (!this.demoText) return
      
      const canvas = this.demoType === 'qrcode' 
        ? this.$refs.demoQrCanvas 
        : this.$refs.demoBarcodeCanvas
        
      if (!canvas) return
      
      const link = document.createElement('a')
      link.download = `demo-${this.demoType}-${Date.now()}.png`
      link.href = canvas.toDataURL()
      link.click()
    }
  }
}
</script>

<style scoped>
.home {
  padding: 20px;
  background-color: #f8fafc;
  min-height: 100vh;
}

.main-container {
  max-width: 1400px;
  margin: 0 auto;
}

.main-content {
  margin-top: 20px;
}

/* 快速体验区域 */
.demo-card {
  border-radius: 12px;
  height: 100%;
}

.demo-title {
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.demo-title i {
  margin-right: 8px;
  color: #409eff;
}

.demo-controls {
  padding-right: 20px;
}

.demo-preview {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  background-color: #f9fafb;
  border-radius: 8px;
  border: 2px dashed #d1d5db;
}

/* 工具面板 */
.tools-panel {
  background: white;
  border-radius: 12px;
  padding: 24px;
  height: 100%;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.panel-header {
  text-align: center;
  margin-bottom: 30px;
}

.panel-header h2 {
  margin: 0 0 8px 0;
  font-size: 22px;
  font-weight: 600;
  color: #2d3748;
}

.panel-header p {
  margin: 0;
  font-size: 14px;
  color: #718096;
}

.tool-buttons {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.tool-button-item {
  display: flex;
  align-items: center;
  padding: 20px;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
}

.tool-button-item:hover {
  border-color: #409eff;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(64, 158, 255, 0.15);
}

.tool-button-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  flex-shrink: 0;
}

.qrcode-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.barcode-icon {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
}

.tool-button-icon i {
  font-size: 28px;
}

.tool-button-content {
  flex: 1;
}

.tool-button-content h3 {
  margin: 0 0 6px 0;
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
}

.tool-button-content p {
  margin: 0 0 12px 0;
  font-size: 13px;
  color: #718096;
  line-height: 1.4;
}

.tool-button-content .el-button {
  font-size: 13px;
  padding: 6px 16px;
}

/* 表单样式 */
.el-form-item {
  margin-bottom: 20px;
}

.el-input__inner, .el-textarea__inner {
  border-radius: 8px;
}

.el-select .el-input__inner {
  border-radius: 8px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .home {
    padding: 10px;
  }
  
  .main-content {
    flex-direction: column;
  }
  
  .main-content .el-col {
    width: 100%;
    margin-bottom: 20px;
  }
  
  .demo-controls {
    padding-right: 0;
    margin-bottom: 20px;
  }
  
  .tool-button-item {
    padding: 16px;
  }
  
  .tool-button-icon {
    width: 48px;
    height: 48px;
  }
  
  .tool-button-icon i {
    font-size: 24px;
  }
}
</style>
